<template>
  <div class="search-container" :style="'background-image: url(' + SearchBg+')'">
    <div class="banner">
      <p class="banner-title">一键查询全国人力资源时政要闻</p>
      <p class="banner-sub-title">
        <span style="margin-right: 10px">680+ 时政要闻</span>
      </p>
    </div>
    <el-card class="search-box-page" :class="{ 'search-box-page-en': lang == 'en' }">
      <div class="search-item">
        <label class="search-item-label" style="padding-right: 11px">{{ $t('keywords') }}</label>
        <div class="search-content">
          <el-input v-model="queryParams.scope" :placeholder="$t('pleaseQuery')" class="input-round" size="medium" suffix-icon="el-icon-search" clearable @change="handleSearch" />
        </div>
      </div>
      <div class="search-item hot-search" v-if="!isSearchPage">
        <label class="search-item-label">{{ $t('hotSearch') }}：</label>
        <div class="search-content">
          <span class="hot-link pointer" v-for="(item, index) in hotSearchList" :key="index" @click="handleHotSearch(item)">{{ item }}</span>
        </div>
      </div>
    </el-card>
    <div class="content-container">
      <all v-if="!isSearchPage"></all>
      <el-row :gutter="20" class="search-result-container" style="margin: auto" v-else v-loading="loading">
        <el-col :span="15">
          <search-result :data="searchResult" :pager-config.sync="pagerConfig" @page-change="pageChange"></search-result>
        </el-col>
        <el-col :span="9">
          <el-col :span="24" class="marginBottom20">
            <hot-search :data="hotSearchList" @search="handleHotSearch"></hot-search>
          </el-col>
          <el-col :span="24">
            <search-history :data="searchHistory" @search="historySearch" @clear="handleClear"></search-history>
          </el-col>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import All from '@/views/policy/policyLibrary/policyExpress/components/All';
  import HotSearch from '@/views/policy/policyLibrary/policyExpress/components/HotSearch';
  import SearchHistory from '@/views/policy/policyLibrary/policyExpress/components/SearchHistory';
  import SearchResult from '@/views/policy/policyLibrary/policyExpress/components/SearchResult';
  import SearchBg from '@/assets/img/policy/search-bg.png';
  import * as api from '@/api/policy/policyLibrary';
  import { mapGetters } from 'vuex';
  export default {
    name: "PolicyExpress",
    components: {
      All,
      HotSearch,
      SearchHistory,
      SearchResult
    },
    created() {
      this.getHotSearchList();
    },
    data() {
      return {
        SearchBg,
        loading: false,
        queryParams:{
          scope: ''
        },
        hotSearchList: [],
        searchHistory: [],
        searchResult: [],
        pagerConfig: {
          page: 1,
          limit: 10,
          total: 0
        },
        isSearchPage: false
      }
    },
    methods: {
      // 获取热门搜索
      getHotSearchList() {
        api.expressHot()
          .then(res => {
            this.hotSearchList = res.data.data;
          })
      },
      // 热门搜索点击，代入查询
      handleHotSearch(val) {
        this.queryParams.scope = val;
        this.pagerConfig.page = 1;
        this.getData();
      },
      // 清空搜索历史
      handleClear() {
        api.expressHistoryDel()
          .then(res => {
            if (res.data.code == 0) {
              this.searchHistory = [];
              this.$message.success('清空成功');
            }
          })
      },
      /**
       * 获取检索数据,调用成功后，同时获取搜索历史
       * @param isSearch
       * isSearch 是否是点击检索（输入框检索、热门搜索检索、搜索历史点击）,分页检索传false
       */
      getData(isSearch = true) {
        this.loading = true;
        this.isSearchPage = true;
        const { page, limit } = this.pagerConfig;
        let params = {
          page: page,
          pageSize: limit,
          scope: this.queryParams.scope
        }
        api.expressList(params)
          .then(res => {
            this.loading = false;
            const { list, total } = res.data.data;
            this.searchResult = list || [];
            this.pagerConfig.total = total || 0;
            if (isSearch) {
              this.getSearchHistoryList();
              this.getHotSearchList();
            }
          })
          .catch(error => {
            this.loading = false;
          })
      },
      // 获取搜索历史
      getSearchHistoryList() {
        api.expressHistory()
          .then(res => {
            this.searchHistory = res.data.data;
          })
      },
      // 搜索历史点击
      historySearch(val) {
        this.queryParams.scope = val;
        this.pagerConfig.page = 1;
        this.getData();
      },
      // 点击搜索
      handleSearch(val) {
        if (val) {
          this.isSearchPage = true;
          this.pagerConfig.page = 1;
          this.getData();
        } else {
          this.isSearchPage = false;
          this.searchHistory = [];
        }
      },
      // 分页
      pageChange({ type, currentPage, pageSize }) {
        if (type == 'size'){
          this.pagerConfig.page = 1;
        }
        this.getData(false);
      }
    },
    computed: {
      ...mapGetters(['dicts', 'lang'])
    }
  }
</script>

<style lang="scss" scoped>

</style>
